<template>
    <q-page class=" rounded-borders q-pa-md border" style="height: 100%; overflow-y: auto">

        <q-dialog v-model="showPreview" maximized>
            <q-card class="column" style="background:#f4f6f9">

                <div class="row items-center q-px-xl q-py-md bg-white"
                    style="border-bottom:1px solid #e3e8ef; flex-shrink:0">
                    <div class="row items-center q-gutter-x-md">
                        <div
                            style="width:44px;height:44px;border-radius:12px;background:linear-gradient(135deg,#1565c0,#42a5f5);display:flex;align-items:center;justify-content:center">
                            <q-icon name="mdi-table" color="white" size="24px" />
                        </div>
                        <div class="column">
                            <span class="text-weight-bold text-grey-9" style="font-size:16px">
                                Vista previa de importación
                            </span>
                            <span class="text-grey-5" style="font-size:12px">
                                Revisa los registros antes de confirmar
                            </span>
                        </div>
                    </div>
                    <q-space />

                    <div class="row q-gutter-x-sm q-mr-lg">
                        <q-chip icon="mdi-check-circle" color="green-1" text-color="green-8" dense>
                            {{previewPacientes.filter(p => !p.errores.length).length}} válidos
                        </q-chip>
                        <q-chip icon="mdi-alert-circle" color="red-1" text-color="red-8" dense>
                            {{previewPacientes.filter(p => p.errores.length).length}} con errores
                        </q-chip>
                        <q-chip icon="mdi-counter" color="blue-1" text-color="blue-8" dense>
                            {{ previewPacientes.length }} total
                        </q-chip>
                    </div>

                    <q-btn outline color="grey-6" label="Cancelar" v-close-popup class="q-mr-sm" />
                    <q-btn unelevated color="primary" icon="mdi-check" label="Confirmar importación"
                        :disable="previewPacientes.filter(p => !p.errores.length).length === 0"
                        @click="confirmarImportacion" />
                </div>

                <div class="col q-pa-xl" style="overflow:auto">
                    <q-card class="shadow-0 bordered rounded-borders overflow-hidden">
                        <q-table dense flat :rows="previewPacientes" :columns="columnsPreview" row-key="fila"
                            :pagination="{ rowsPerPage: 20 }">
                      
                            <template v-slot:body="props">
                                <q-tr :props="props" :class="props.row.errores.length ? 'fila-error' : 'fila-ok'">
                                    <q-td key="nombres" :props="props">{{ props.row.nombres }}</q-td>
                                    <q-td key="apellidoPaterno" :props="props">{{ props.row.apellidoPaterno }}</q-td>
                                    <q-td key="apellidoMaterno" :props="props">{{ props.row.apellidoMaterno }}</q-td>
                                    <q-td key="hospitalProcedencia" :props="props">{{ props.row.hospitalProcedencia
                                        }}</q-td>
                                    <q-td key="direccion" :props="props">{{ props.row.direccion }}</q-td>
                                    <q-td key="telefono" :props="props">{{ props.row.telefono }}</q-td>
                                    <q-td key="celular" :props="props">{{ props.row.celular }}</q-td>

                                    <q-td key="errores">
                                        <div v-if="props.row.errores.length" class="row q-gutter-xs">
                                            <q-chip v-for="err in props.row.errores" :key="err" dense icon="mdi-alert"
                                                color="red-1" text-color="red-8" style="font-size:11px">
                                                {{ err }}
                                            </q-chip>
                                        </div>
                                        <q-chip v-else dense icon="mdi-check" color="green-1" text-color="green-8"
                                            style="font-size:11px">
                                            Correcto
                                        </q-chip>
                                    </q-td>
                                </q-tr>
                            </template>
                            <template v-slot:no-data>
                                <div class="column items-center q-pa-xl text-grey-5 full-width">
                                    <q-icon name="mdi-table-off" size="48px" class="q-mb-sm" />
                                    <span>Sin datos para mostrar</span>
                                </div>
                            </template>
                        </q-table>
                    </q-card>
                </div>

            </q-card>
        </q-dialog>

        <!-- DIALOG DE CONFIRMACION DE DELETE -->
        <q-dialog v-model="showDelete" backdrop-filter=" blur(4px) saturate(150%)">
            <q-card class="q-pa-md" style="width: 600px; max-width: 120vw;">
                <q-card-section class="row items-center q-gutter-sm">
                    <q-icon name="warning" color="negative" size="50px" />
                    <q-separator vertical />
                    <div class="q-ml-lg text-h5">Eliminar Paciente</div>
                </q-card-section>
                <q-card-section class="text-grey-7">
                    <p style="font-size:18px">¿Deseas eliminar el paciente <b>{{ itemToDelete.nombres + ' ' +
                        itemToDelete.apellidoPaterno + ' ' + itemToDelete.apellidoMaterno }}</b>?
                        <br />
                        <b>Esta acción no se puede deshacer.</b>
                    </p>
                </q-card-section>
                <q-card-actions class="q-col-gutter-md">
                    <div class="col">
                        <q-btn outline class="full-width" label="Cancelar" color="grey-7" v-close-popup />
                    </div>
                    <div class="col">
                        <q-btn class="full-width" outline label="Eliminar" color="red" @click="deletePaciente" />
                    </div>
                </q-card-actions>
            </q-card>
        </q-dialog>

        <!-- CARD PARA NUEVO PACIENTE -->
        <q-card v-if="showForm" class="q-pa-xl shadow-0 full-height rounded-borders">
            <q-card-section class="q-pa-none q-mb-lg">
                <div class="row items-center justify-between q-col-gutter-md">
                    <div class="col">
                        <div class="text-h6 text-primary">Nuevo Paciente</div>
                        <div class="text-subtitle2 text-grey">
                            Registra los datos generales para poder dar de alta un paciente
                        </div>
                    </div>
                    <div class="col-auto">
                        <q-btn v-if="!showEdit" color="primary" icon="save" label="Guardar Paciente"
                            @click="savePaciente()" class="q-ml-sm" style="min-width: 250px" />
                        <q-btn v-else color="primary" icon="save" label="Actualizar Paciente" @click="editPaciente()"
                            class="q-ml-sm" style="min-width: 250px" />
                        <q-btn color="primary" icon="mdi-magnify" label="Buscar Paciente" @click="mostrarPacientes()"
                            class="q-ml-sm" style="min-width: 250px" />
                    </div>
                </div>
            </q-card-section>
            <q-separator class="q-mb-md bg-primary" />
            <q-card-section class="q-pa-none q-mb-lg">
                <Paciente></Paciente>
            </q-card-section>
        </q-card>

        <!-- CARD PARA VER EL EXPEDIENTE -->
        <q-card v-if="showExpediente" class="q-pa-xl shadow-0   rounded-borders">
            <q-card-section class="q-pa-none q-mb-lg">
                <div class="row items-center justify-between q-col-gutter-md">
                    <div class="col-12">
                        <div class="text-h6 text-primary">Expediente</div>
                        <div class="text-subtitle2 text-grey">
                            En el expediente de cada paciente podras visualizar la información recaudada en cada visita
                        </div>
                    </div>
                    <div class="col-12 row   no-wrap">
                        <q-field filled dense style="width: 100%" label="Paciente" stack-label>
                            <template v-slot:control>
                                <div class="self-center full-width no-outline" tabindex="0">
                                    {{ paciente.nombres + ' ' + paciente.apellidoPaterno + ' ' +
                                        paciente.apellidoMaterno }}
                                </div>
                            </template>
                        </q-field>
                        <q-btn color="primary" icon="mdi-format-list-bulleted" label="Lista de Pacientes"
                            @click="mostrarPacientes()" class="q-ml-sm" style="min-width: 250px" />
                    </div>
                </div>
            </q-card-section>
            <q-card-section class="q-pa-none q-mb-lg">
                <Expediente></Expediente>
            </q-card-section>
        </q-card>

        <!-- CARD PARA LISTA DE PACIENTES -->
        <q-card v-if="!showForm && !showExpediente" class="q-pa-xl shadow-0 full-height rounded-borders">
            <q-card-section class="q-pa-none q-mb-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="text-h6 text-primary">Pacientes</div>
                        <div class="text-subtitle2 text-grey">
                            Aquí podrás gestionar la información y detalles de tus pacientes
                        </div>
                    </div>
                    <div class="col-12 row no-wrap justify-end q-mt-md">
                        <q-input filled class="q-mr-sm" dense style="width: 100%" debounce="300" v-model="filtro"
                            placeholder="Buscar">
                            <template v-slot:append>
                                <q-icon name="search" />
                            </template>
                        </q-input>
                        <q-btn color="primary" style="min-width: 200px" icon="refresh" label="Consultar"
                            @click="getPacientes()" />
                        <q-btn color="primary" class="q-ml-sm" style="min-width: 250px" icon="add_circle"
                            label="Nuevo Paciente" @click="nuevoPaciente" />

                        <q-btn-dropdown color="primary" class="q-ml-sm" style="min-width: 250px" icon="mdi-import"
                            label="Importar">
                            <q-list>
                                <q-item clickable v-close-popup @click="seleccionarArchivo">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-file-upload" color="primary" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>Importar Excel</q-item-label>
                                        <q-item-label caption>Sube tu archivo .xlsx</q-item-label>
                                    </q-item-section>
                                </q-item>

                                <q-item clickable v-close-popup @click="descargarPlantilla">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-file-download" color="positive" />
                                    </q-item-section>
                                    <q-item-section>
                                        <q-item-label>Descargar Plantilla</q-item-label>
                                        <q-item-label caption>Formato con las columnas requeridas</q-item-label>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </q-btn-dropdown>
                        <!-- <q-btn color="primary" class="q-ml-sm" style="min-width: 250px" icon="mdi-import"
                            label="Importar" @click="seleccionarArchivo" />-->
                        <input type="file" ref="fileInput" style="display: none" accept=".xlsx, .xls"
                            @change="leerExcel" />

                    </div>
                </div>
            </q-card-section>

            <q-separator class="q-mb-md bg-primary" />
            <q-table dense bordered class="shadow-0" :rows="pacientes" :loading="loading" :columns="columns"
                color="primary" row-key="_id" :pagination="initialPagination" :filter="filtro">
                <template v-slot:body="props">
                    <q-tr :props="props" class="hover-fila">
                        <q-td key="acciones">
                            <q-btn flat round color="blue" icon="mdi-pencil" @click="editarPaciente(props.row)" />
                            <q-btn flat round color="red" icon="delete" @click="abrirDialogDelete(props.row)" />
                        </q-td>
                        <q-td key="nombres" :props="props">{{ props.row.nombres }}</q-td>
                        <q-td key="apellidoPaterno" :props="props">{{ props.row.apellidoPaterno }}</q-td>
                        <q-td key="apellidoMaterno" :props="props">{{ props.row.apellidoMaterno }}</q-td>
                        <q-td key="hospitalProcedencia" :props="props">{{ props.row.hospitalProcedencia }}</q-td>
                        <q-td key="direccion" :props="props">{{ props.row.direccion }}</q-td>
                        <q-td key="telefono" :props="props">{{ props.row.telefono }}</q-td>
                        <q-td key="celular" :props="props">{{ props.row.celular }}</q-td>
                        <q-td key="avisoPrivacidad" :props="props">
                            <q-icon v-if="props.row.avisoPrivacidad == false" color="red" size="32px"
                                name="mdi-alert-circle" />
                            <q-icon v-if="props.row.avisoPrivacidad == true" color="green" size="32px"
                                name="mdi-check-circle" />
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
        </q-card>
    </q-page>
</template>
<script setup>
import { ref } from "vue";
import { useStore } from 'vuex'
import { useRouter } from "vue-router";
import { computed, onBeforeMount } from 'vue'
import axios from 'axios'
import Paciente from './Paciente.vue'
import Expediente from '../Expediente/Expediente.vue'
import { Notify, useQuasar, QSpinnerFacebook } from 'quasar'
import * as XLSX from 'xlsx'

const fileInput = ref(null)
const $q = useQuasar()
const $router = useRouter()
const store = useStore()

const loading = ref(false);
const showForm = ref(false)
const pacientes = ref([]);
const filtro = ref('');

let itemToDelete = null
const showDelete = ref(false)
const showEdit = ref(false)
const showExpediente = ref(false);

const previewPacientes = ref([])
const showPreview = ref(false)
const erroresExcel = ref([])

onBeforeMount(() => {
    getPacientes();
})


const paciente = computed({
    get: () => store.state.pacienteStore,
    set: (val) => store.state.pacienteStore = val
})

const usuario = computed({
    get: () => store.state.usuario,
    set: (val) => store.state.usuario = val
})

const columns = ref([
    { name: 'acciones', label: 'Acciones', field: 'acciones', align: 'center', sortable: true },
    { name: 'nombres', label: 'Nombre(s)', field: 'nombres', align: 'center', sortable: true },
    { name: 'apellidoPaterno', label: 'Apellido Paterno', field: 'apellidoPaterno', align: 'center', sortable: true },
    { name: 'apellidoMaterno', label: 'Apellido Materno', field: 'apellidoMaterno', align: 'center', sortable: true },
    { name: 'hospitalProcedencia', label: 'Hospital de Procedencia', field: 'hospitalProcedencia', align: 'center', sortable: true },
    { name: 'direccion', label: 'Dirección', field: 'direccion', align: 'center', sortable: true },
    { name: 'telefono', label: 'Teléfono', field: 'telefono', align: 'center', sortable: true },
    { name: 'celular', label: 'Celular', field: 'celular', align: 'center', sortable: true },
    { name: 'avisoPrivacidad', label: 'Acepto el Aviso de Privacidad', field: 'avisoPrivacidad', align: 'center' },
]);

const columnsPreview = [
    // { name: 'fila', label: 'Fila', field: 'fila', align: 'center', sortable: true  },
    { name: 'nombres', label: 'Nombre(s)', field: 'nombres', align: 'center', sortable: true },
    { name: 'apellidoPaterno', label: 'Apellido Paterno', field: 'apellidoPaterno', align: 'center', sortable: true },
    { name: 'apellidoMaterno', label: 'Apellido Materno', field: 'apellidoMaterno', align: 'center', sortable: true },
    { name: 'hospitalProcedencia', label: 'Hospital de Procedencia', field: 'hospitalProcedencia', align: 'center', sortable: true },
    { name: 'direccion', label: 'Dirección', field: 'direccion', align: 'center', sortable: true },
    { name: 'telefono', label: 'Teléfono', field: 'telefono', align: 'center', sortable: true },
    { name: 'celular', label: 'Celular', field: 'celular', align: 'center', sortable: true },
    { name: 'errores', label: 'Errores', field: 'errores', align: 'center', sortable: true }
]



const initialPagination = ref({
    sortBy: "nombres",
    descending: false,
    page: 1,
    rowsPerPage: 10,
});

const nuevoPaciente = () => {
    const objeto = {
        nombres: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        direccion: '',
        telefono: '',
        celular: '',
        diagnostico: '',
        hospitalProcedencia: '',
        creadoPorUsuarioId: usuario.value._id,
    }
    store.state.pacienteStore = { ...objeto }
    showForm.value = true

}

const procesarPacientes = (data) => {

    const pacientesMapeados = data.map((item, index) => {

        let errores = []

        if (!item.Nombres) errores.push('Falta nombre')
        if (!item.ApellidoPaterno) errores.push('Falta apellido paterno')
        if (!item.Telefono) errores.push('Falta teléfono')

        const telefono = formatearTelefono(item.Telefono)
        const celular = formatearTelefono(item.Celular)

        return {
            nombres: item.Nombres || '',
            apellidoPaterno: item.ApellidoPaterno || '',
            apellidoMaterno: item.ApellidoMaterno || '',
            direccion: item.Direccion || '',
            telefono: telefono,
            celular: celular,
            diagnostico: item.Diagnostico || '',
            hospitalProcedencia: item.HospitalProcedencia || '',
            creadoPorUsuarioId: usuario.value._id,
            errores,
            fila: index + 2 // por header
        }
    })

    previewPacientes.value = pacientesMapeados
    showPreview.value = true
}

const seleccionarArchivo = () => {
    fileInput.value.click()
}
// Agrega esta función en el <script setup> junto a las demás

function descargarPlantilla() {
    // Columnas exactas que espera procesarPacientes()
    const encabezados = [
        'Nombres',
        'ApellidoPaterno',
        'ApellidoMaterno',
        'Direccion',
        'Telefono',
        'Celular',
        'Diagnostico',
        'HospitalProcedencia',
    ]

    // Fila de ejemplo para que el usuario entienda el formato
    const ejemplo = [
        'Juan Carlos',
        'García',
        'López',
        'Calle Reforma 123, Col. Centro',
        '2221234567',
        '2229876543',
        'Lumbalgia crónica',
        'IMSS HGZ 20',
    ]

    const worksheet = XLSX.utils.aoa_to_sheet([encabezados, ejemplo])

    // Ancho de columnas para que sea más legible
    worksheet['!cols'] = encabezados.map(() => ({ wch: 24 }))

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Pacientes')

    XLSX.writeFile(workbook, 'Plantilla_Pacientes.xlsx')
}

const leerExcel = (event) => {
    const file = event.target.files[0]
    if (!file) return

    const reader = new FileReader()

    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })

        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]

        const jsonData = XLSX.utils.sheet_to_json(worksheet)

        console.log('Excel leído:', jsonData)

        procesarPacientes(jsonData)
    }

    reader.readAsArrayBuffer(file)
}

const confirmarImportacion = () => {

    const validos = previewPacientes.value.filter(p => p.errores.length === 0)

    if (validos.length === 0) {
        Notify.create({
            message: 'No hay registros válidos para importar',
            color: 'negative'
        })
        return
    }

    guardarMasivo(validos)
    showPreview.value = false
}

const formatearTelefono = (numero) => {
    if (!numero) return ''

    // quitar todo lo que no sea número
    const limpio = numero.toString().replace(/\D/g, '')

    // asegurar 10 dígitos
    if (limpio.length !== 10) return numero

    return `(${limpio.substring(0, 3)}) - ${limpio.substring(3, 6)} - ${limpio.substring(6, 10)}`
}

const guardarMasivo = async (pacientes) => {

    $q.loading.show({
        message: 'Importando pacientes...'
    })
    console.log(pacientes)

    try {
        const response = await axios.post('/Pacientes/CreaPacienteLista', pacientes)
    console.log(response)
        Notify.create({
            message: 'Pacientes importados correctamente',
            color: 'positive',
            position: 'top-right'
        })

        getPacientes()

    } catch (error) {
        console.error(error)

        Notify.create({
            message: 'Error al importar pacientes',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
    }
}

function verExpediente(item) {
    store.state.pacienteStore = item
    showExpediente.value = true
}

const getPacientes = async () => {
    loading.value = true
    try {
        const response = await axios.get('/Pacientes')
        console.log('Respuesta backend:', response.data)
        pacientes.value = response.data
    } catch (error) {
        console.error(error)
        Notify.create({
            message: 'Error al consultar los pacientes',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        loading.value = false
    }
}

const savePaciente = async () => {
    if (paciente.value.nombres == '') {
        Notify.create({
            message: 'Ingrese los nombres del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.apellidoPaterno == '') {
        Notify.create({
            message: 'Ingrese los apelldios paternos del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.apellidoMaterno == '') {
        Notify.create({
            message: 'Ingrese los apelldios maternos del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.direccion == '') {
        Notify.create({
            message: 'Ingrese la dirección del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.telefono == '') {
        Notify.create({
            message: 'Ingrese el teléfono del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.diagnostico == '') {
        Notify.create({
            message: 'Ingrese el diagnóstico del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.hospitalProcedencia == '') {
        Notify.create({
            message: 'Ingrese el hospital de procedencia del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }


    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Guardando paciente...'
    })

    try {
        console.log(paciente)
        const response = await axios.post('Pacientes', paciente.value)
        console.log('Respuesta backend:', response.data)

        Notify.create({
            message: 'Paciente guardado correctamente',
            color: 'positive',
            position: 'top-right'
        })

    } catch (error) {
        console.error('Error al guardar:', error)

        Notify.create({
            message: 'Error al guardar paciente',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
        nuevoPaciente();
    }
}

const deletePaciente = async () => {
    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Eliminando paciente...'
    })

    try {
        const response = await axios.delete('Pacientes/' + itemToDelete.id)
        console.log(response)

        Notify.create({
            message: 'Paciente eliminado correctamente',
            color: 'positive',
            position: 'top-right'
        })

        getPacientes();
    } catch (error) {
        console.error('Error al eliminar:', error)

        Notify.create({
            message: 'Error al eliminar paciente',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
        showDelete.value = false;
    }
}

const editPaciente = async () => {
    if (paciente.value.telefono == '') {
        Notify.create({
            message: 'Ingrese el teléfono del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.diagnostico == '') {
        Notify.create({
            message: 'Ingrese el diagnóstico del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }
    if (paciente.value.hospitalProcedencia == '') {
        Notify.create({
            message: 'Ingrese el hospital de procedencia del paciente.',
            color: 'info',
            position: 'top-right',
            type: 'info'
        })
        return
    }


    $q.loading.show({
        spinner: QSpinnerFacebook,
        spinnerColor: 'primary',
        spinnerSize: 100,
        message: 'Guardando paciente...'
    })

    try {
        console.log(paciente)
        let objeto = {
            direccion: paciente.value.direccion,
            telefono: paciente.value.telefono,
            celular: paciente.value.celular,
            creadoPorUsuarioId: usuario.value._id,
        }
        console.log(objeto)

        const response = await axios.put('Pacientes/' + paciente.value.id, objeto)
        console.log('Respuesta backend:', response.data)

        Notify.create({
            message: 'Paciente actualizado correctamente',
            color: 'positive',
            position: 'top-right'
        })

    } catch (error) {
        console.error('Error al guardar:', error)
        Notify.create({
            message: 'Error al actualizar paciente',
            color: 'negative',
            position: 'top-right'
        })
    } finally {
        $q.loading.hide()
        nuevoPaciente();
        showEdit.value = false
        showForm.value = false
    }
}


const abrirDialogDelete = (item) => {
    itemToDelete = item
    showDelete.value = true
}

const mostrarPacientes = () => {
    showForm.value = false
    showEdit.value = false
    showExpediente.value = false
}

const editarPaciente = (item) => {
    store.state.pacienteStore = { ...item }
    showEdit.value = true
    showForm.value = true
}
</script>